import dayjs from 'dayjs'
import { useMemo } from 'react'
import { MentionSubject } from '../utils/smartLinks/types'

export function useLastEditedFormatted(mentionSubject?: MentionSubject | null) {
  return useMemo(() => {
    const lastEditedBy = mentionSubject?.lastEditedBy ? mentionSubject?.lastEditedBy : undefined
    const lastEditedAt = mentionSubject?.lastEditedAt
      ? `Last edited ${dayjs(mentionSubject.lastEditedAt).format('MMM D')}`
      : undefined

    if (lastEditedBy && lastEditedAt) {
      return `${lastEditedAt} by ${lastEditedBy}`
    } else if (lastEditedAt) {
      return lastEditedAt
    }
    return ''
  }, [mentionSubject])
}
